import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FEATURES } from '../../config/environment';
import './Navigation.css';

const Navigation = () => {
  const location = useLocation();

  const navItems = [
    { path: '/celebrities', label: 'Celebrities', enabled: true },
    { path: '/companies', label: 'Companies', enabled: true },
    { path: '/caa-partnership', label: '2025 Promos', enabled: true },
    { path: '/live-streams', label: 'Live Streams', enabled: FEATURES.LIVE_STREAMS },
    { path: '/rewards', label: 'Rewards', enabled: FEATURES.REWARDS },
  ];

  const handleDisabledClick = (e, label) => {
    e.preventDefault();
    // Could show a tooltip or notification here
    console.log(`${label} feature coming soon`);
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <span className="logo-text">squad</span>
          <span className="logo-dot">.</span>
        </Link>

        <div className="nav-menu">
          {navItems.map((item) => (
            item.enabled ? (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
              >
                {item.label}
              </Link>
            ) : (
              <a
                key={item.path}
                href="#"
                className="nav-link disabled"
                onClick={(e) => handleDisabledClick(e, item.label)}
                title="Coming Soon"
              >
                {item.label}
              </a>
            )
          ))}
        </div>

        <button className="contact-button">
          Contact
        </button>
      </div>
    </nav>
  );
};

export default Navigation;